import React, { Component } from 'react';
import './RequestList.css';
import api from '../../configs/api';
import qs from 'qs';
import elvisApi from '../../helpers/elvisApi';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import AssetList from '../../components/AssetList/AssetList';
import { NavLink } from 'react-router-dom';
import { AppStateConsumer } from '../../providers/AppState';
import GoogleAnalytics from 'react-ga';

class RequestList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assetList: [],
      activeShare: null,
      share: null,
      requestList: localStorage.requestList ? JSON.parse(localStorage.requestList) : { shareId: null, items: [] },
      settings: {},
      ui: {
        assetsLoading: false,
        assetsLoadingSuccess: false,

        sendingRequest: false,
      }
    };
  }

  async search() {
    this.setState({
      ui: {
        ...this.state.ui,
        assetsLoading: true,
      }
    });

    try {
      let results;
      let share;

      if (this.state.requestList?.shareId) {
        try {
          share = await api.getShare(this.state.requestList.shareId);
          const requestedAssets = this.state.requestList.items.filter(id => share.requestedImages.includes(id));
          requestedAssets.forEach(id => {
            this.toggleRequest(id);
          });

          this.setState({ share });
        } catch (error) {
          console.error('Couldn\'t fetch share!');
        }

        if (this.state.requestList.items.length > 0) {
          results = await api.sharedSearch({ id: this.state.requestList.shareId }, {
            q: `id:${this.state.requestList.items.join(' OR id:')}`,
            num: 1000,
            start: 0,
          });

          this.setState({
            assetList: results.hits.map(hit => ({
              id: hit.id,
              name: hit.metadata.name,
              thumbnail: api.getAssetThumbnail(hit, this.URLSearchParams.token),
              url: '/',
              metadata: hit.metadata,
            })),
            ui: {
              ...this.state.ui,
              assetsLoading: false,
              assetsLoadingSuccess: true,
            }
          });
        } else {
          this.setState({
            assetList: [],
            ui: {
              ...this.state.ui,
              assetsLoading: false,
              assetsLoadingSuccess: true,
            }
          });
        }
      }

    } catch (error) {
      if (error.status == 404) {
        this.setState({
          assetList: [],
          ui: {
            ...this.state.ui,
            assetsLoading: false,
            assetsLoadingSuccess: true,
          }
        });
      } else {
        // TODO: Improve error handling
        console.error('Couldn\'t fetch assets!');
        this.setState({
          assetList: [],
          ui: {
            ...this.state.ui,
            assetsLoading: false,
            assetsLoadingSuccess: true,
          }
        });
      }
    }
  }

  toggleRequest(id) {
    let requestList = localStorage.requestList && JSON.parse(localStorage.requestList);
    // debugger
    if (requestList?.shareId && requestList.items?.length > 0 && requestList.shareId !== this.state.requestList.shareId) {
      if (window.confirm('Request list contains assets from another "Share". We need to clear these assets to add this asset to the basket. Do you agree?')) {
        this.resetRequests();
        requestList = {
          shareId: this.state.requestList.shareId,
          items: []
        }
      }
    }

    if (!requestList || !requestList.shareId) {
      requestList = {
        shareId: this.state.requestList.shareId,
        items: [id]
      }
    }

    if (requestList.items.includes(id)) {
      requestList = {
        ...requestList,
        items: requestList.items.filter(item => item !== id)
      };
    } else {
      requestList.items.push(id)
    }

    this.setState({ requestList });
    localStorage.requestList = JSON.stringify(requestList);
  }

  async componentDidMount() {
    await api.getSettings().then(settingsList => {

      const itemPerPage = parseInt(settingsList.find(({ name }) => name === 'general').config.itemPerPage, 10);
      const general = {
        ...settingsList.find(({ name }) => name === 'general').config,
        itemPerPage,
      };

      const sortingList = settingsList.find(({ name }) => name === 'assets-sorting-list').config.list;
      const assetMetadataList = settingsList.find(({ name }) => name === 'asset-item-metadata-list').config.list;
      const style = settingsList.find(({ name }) => name === 'style').config;


      const settings = {
        general,
        sortingList,
        assetMetadataList,
        style
      };

      this.setState({ settings }, () => {
        if (this.state.requestList?.items.length > 0) {
          this.search();
        } else {
          this.setState({
            ui: {
              ...this.state.ui,
              assetsLoading: false,
              assetsLoadingSuccess: true,
            }
          });
        }
      });
    });
  }

  get downloadURL() {
    if (this.isPrivate) {
      return api.getPrivateDownloadURL(this.URLSearchParams.token);
    } if (this.activeTab === 'share') {
      return api.getUserDownloadURL();
    } else {
      return api.getDownloadURL();
    }
  }


  resetRequests() {
    localStorage.requestList = JSON.stringify({
      shareId: null,
      items: []
    });

    this.setState({
      assetList: [],
      requestList: {
        shareId: null,
        items: []
      }
    });
  }

  requestAll() {
    this.setState({
      ui: {
        ...this.state.ui,
        sendingRequest: true,
      }
    });

    api.requestOriginal(this.state.share.id, this.state.requestList.items).then(() => {
      this.setState({
        ui: {
          ...this.state.ui,
          sendingRequest: false,
        }
      });

      this.resetRequests();
      this.setState({
        assetList: [],
      });
    })
      .catch(error => {
        window.alert(
          `Couldn't send request.\n${error?.body?.message?.[0]?.messages?.[0]?.id}`);
        this.setState({
          ui: {
            ...this.state.ui,
            sendingRequest: false,
          }
        });
      });
  }

  get URLSearchParams() {
    return qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
  }

  get isPrivate() {
    return !!this.URLSearchParams.token;
  }

  render() {
    return (
      <div className='ems-container'>
        <Header
          settings={this.state.settings.general}
          isAuthenticated={true}
          token={this.URLSearchParams.token} />
        <div className='ems-margin-top ems-request-basket ems-request-basket ems-main'>
          <div className="ems-main-inner">
            {this.state.settings.general && <AssetList
              itemPath={elvisApi.csrfToken ? 'item' : 'share-item'}
              ui={this.state.ui}
              activeShare={this.state.share}
              type={"share"}
              requestList={this.state.requestList.shareId === this.state.share?.id ? this.state.requestList.items : []}
              token={this.URLSearchParams.token}
              settings={this.state.settings}
              assetHeadline={
                <div className='ems-margin-bottom'>
                  <h2 className='ems-heading ems-asset-results-heading'>Requested Assets</h2>
                  <div className='ems-request-basket-buttons'>
                    <button className='ems-button ems-request-list-request-all' onClick={e => this.requestAll(e)} disabled={this.state.ui.sendingRequest}>
                      {this.state.ui.sendingRequest ? 
                        this.state.settings?.style?.watermark?.text?.sendingRequest || 'Sending Request...' : 
                        this.state.settings?.style?.watermark?.text?.requestOriginals || 'Request Originals'
                      }
                    </button>
                    <button className='ems-button ems-request-list-clear' onClick={e => this.resetRequests(e)}>{this.state.settings?.style?.watermark?.text?.clearAllRequests || "Clear"}</button>
                  </div>
                </div>}
              assetList={this.state.assetList}
              toggleRequest={this.toggleRequest.bind(this)}
              basketList={[]} />
            }
          </div>
        </div>
        <Footer settings={this.state.generalSiteSettings} />
      </div>
    );
  }
}

export default RequestList;
